import React from "react";
import PropTypes from "prop-types";
import RuleRowText from "../../RulesRenderer/RuleRowText/RuleRowText";

const SimpleTypeDisplay = ({ rule }) => {
    return (
        <div data-component="Rules\List\ComponentBuilder\SimpleTypeDisplay">
            <RuleRowText column="action" rule={rule} />
        </div>
    );
};

SimpleTypeDisplay.propTypes = {
    rule: PropTypes.shape({
        ruleType: PropTypes.string.isRequired,
    }),
    formType: PropTypes.string.isRequired,
};

export default SimpleTypeDisplay;
